function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M19.571,16.684a2.786,2.786,0,0,0-1.443.411L15.9,14.858a4.33,4.33,0,0,0,0-5.009l2.23-2.236a2.786,2.786,0,0,0,1.443.411,2.887,2.887,0,1,0-2.887-2.887A2.786,2.786,0,0,0,17.1,6.58L14.858,8.81a4.33,4.33,0,0,0-5.009,0L7.612,6.58a2.786,2.786,0,0,0,.411-1.443A2.887,2.887,0,1,0,5.137,8.024,2.786,2.786,0,0,0,6.58,7.612L8.81,9.85a4.33,4.33,0,0,0,0,5.009L6.58,17.1a2.786,2.786,0,0,0-1.443-.411,2.887,2.887,0,1,0,2.887,2.887,2.786,2.786,0,0,0-.411-1.443L9.85,15.9a4.33,4.33,0,0,0,5.009,0l2.238,2.23a2.786,2.786,0,0,0-.411,1.443,2.887,2.887,0,1,0,2.887-2.887Zm-7.217-1.443a2.887,2.887,0,1,1,2.887-2.887A2.887,2.887,0,0,1,12.354,15.241Z",
  transform: "translate(-2.25 -2.25)",
  fill: "#d6d6d6"
});

var Svg3RdPartyConnected = function Svg3RdPartyConnected(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20.209,
    height: 20.208,
    viewBox: "0 0 20.209 20.208",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Svg3RdPartyConnected, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/3rd-party-connected.fa0cc067.svg";
export { ForwardRef as ReactComponent };